import { Expose, Type } from "class-transformer";
import { IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export default class OrderItemsListItem {
  @IsString()
  @Expose()
  id!: string;
  @IsOptional()
  @IsString()
  @Expose()
  parentOrderItemId!: null | string;
  @IsOptional()
  @IsNumber()
  @Expose()
  bookingItemId!: null | number;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  ordinal!: number;
  @IsNumber()
  @Expose()
  purchaseNetPrice!: number;
  @IsNumber()
  @Expose()
  purchaseNetPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  ownerId!: number | null;
  @IsOptional()
  @IsString()
  @Expose()
  orderOwners!: null | string;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  purchaseNetPriceCurrency!: string;
  @IsNumber()
  @Expose()
  purchaseNetPriceExchangeRate!: number;
  @IsNumber()
  @Expose()
  profit!: number;
  @IsString()
  @Expose()
  profitCurrency!: string;
  @IsString()
  @Expose()
  purchaseNetPriceExchangeDate!: string;
  @Type(() => OrderItemsListItem)
  @ValidateNested()
  @Expose()
  orderItems!: Array<OrderItemsListItem>;
}

export class OrderItemsListResponse extends GenericTableResponse<OrderItemsListItem> {
  @Type(() => OrderItemsListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<OrderItemsListItem>;
}
